import * as actionTypes from './actionTypes'
import * as API from '../../api/Admin/Blog'

export const adminAddBlogAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_BLOG_ADD_REQUEST, payload: data})
        return API.blogAddApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_BLOG_ADD_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_BLOG_ADD_ERROR, payload:error})    
            })
    }
}


export const adminListBlogAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_BLOG_LIST_REQUEST, payload: data})
        return API.blogListApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_BLOG_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_BLOG_LIST_ERROR, payload:error})    
            })
    }
}

export const adminBlogStatusAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_BLOG_STATUS_CHANGE_REQUEST, payload: data})
        return API.blogDeleteApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_BLOG_STATUS_CHANGE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_BLOG_STATUS_CHANGE_ERROR, payload:error})    
            })
    }
}

export const adminUpdateBlogAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADMIN_BLOG_UPDATE_REQUEST, payload: data})
        return API.blogUpdateApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.ADMIN_BLOG_UPDATE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADMIN_BLOG_UPDATE_ERROR, payload:error})    
            })
    }
}






// WEBPACK FOOTER //
// ./src/actions/Admin/Blog.js